"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPresumedAddressType = getPresumedAddressType;
exports.getPickupAddressTypeDescription = getPickupAddressTypeDescription;
exports.getAddressSpecification = getAddressSpecification;
exports.getAddressWithoutSpecification = getAddressWithoutSpecification;
exports.resolveAddressType = resolveAddressType;
exports.mergePickupAddressAndSpecification = mergePickupAddressAndSpecification;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const value_checkers_1 = require("./value-checkers");
function stripDiacritics(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
const FLIGHT_NUMBER_DESCRIPTION = "Flight number: ";
const SHIP_NAME_DESCRIPTION = "Ship name: ";
const TRAIN_NUMBER_DESCRIPTION = "Train number: ";
const MINIMAL_SEARCH_STRING_LENGTH = 3;
function checkIfAddressIsAirport(address) {
    let isAirport = false;
    // if address doesn't contain flight number, but is marked as flight/fly etc.
    const airportIndicators = [
        "flight",
        "fly",
        "flying",
        "landing",
        "airport",
        "plane",
        "airfield",
        "arrivals",
        "aeroporto",
        "aeropuerto",
    ];
    const addressSplitted = address.split(/[\s,،.]+/);
    addressSplitted.map((word) => {
        if (airportIndicators.indexOf(stripDiacritics(word.toLowerCase())) > -1) {
            isAirport = true;
        }
        return isAirport;
    });
    return isAirport;
}
function checkIfAddressIsBoat(address) {
    const boatIndicators = [
        "boat",
        "ship",
        "viking",
        "uniworld",
        "ama",
        "dock",
        "docking",
        "port",
        "ferry",
        "cruise",
        "marina",
        "msc",
        "harbour",
    ];
    const addressSplitted = address.split(/[\s,،.]+/);
    let isBoat = false;
    addressSplitted.map((word) => {
        if (boatIndicators.indexOf(stripDiacritics(word.toLowerCase())) > -1) {
            isBoat = true;
        }
        return isBoat;
    });
    return isBoat;
}
function checkIfAddressIsTrain(address) {
    const trainIndicators = [
        "train",
        "rail",
        "railway",
        "centrale",
        "central",
        "railroad",
        "station",
        "stazione",
        "tgv",
        "gare",
        "afragola",
    ];
    const addressSplitted = address.split(/[\s,،.]+/);
    let isTrain = false;
    addressSplitted.map((word) => {
        if (trainIndicators.indexOf(stripDiacritics(word.toLowerCase())) > -1) {
            isTrain = true;
        }
        return isTrain;
    });
    return isTrain;
}
function getPresumedAddressType(address) {
    if (address && address.length > MINIMAL_SEARCH_STRING_LENGTH) {
        if (checkIfAddressIsAirport(address)) {
            return legacy_enums_1.LocationAddressType.Airport;
        }
        if (checkIfAddressIsBoat(address)) {
            return legacy_enums_1.LocationAddressType.Port;
        }
        if (checkIfAddressIsTrain(address)) {
            return legacy_enums_1.LocationAddressType.Train;
        }
    }
    return undefined;
}
function getPickupAddressTypeDescription(pickupAddressType) {
    switch (pickupAddressType) {
        case legacy_enums_1.LocationAddressType.Airport:
            return FLIGHT_NUMBER_DESCRIPTION;
        case legacy_enums_1.LocationAddressType.Port:
            return SHIP_NAME_DESCRIPTION;
        case legacy_enums_1.LocationAddressType.Train:
            return TRAIN_NUMBER_DESCRIPTION;
        default:
            return "";
    }
}
function getAddressSpecification(address) {
    if (address.includes("[") &&
        address.includes("]") &&
        (address.includes(FLIGHT_NUMBER_DESCRIPTION) ||
            address.includes(SHIP_NAME_DESCRIPTION) ||
            address.includes(TRAIN_NUMBER_DESCRIPTION))) {
        const specificationDescriptionRegexp = new RegExp(`${FLIGHT_NUMBER_DESCRIPTION}|${SHIP_NAME_DESCRIPTION}|${TRAIN_NUMBER_DESCRIPTION}`, "g");
        return address.replace(/(^.*\[|\].*$)/g, "").replace(specificationDescriptionRegexp, "");
    }
    return "";
}
function getAddressWithoutSpecification(address) {
    return address.replace(/ \[.*?\]/g, "");
}
function resolveAddressType(args) {
    // flight number indicates that the address is an airport
    if (args.flightNumber) {
        return legacy_enums_1.LocationAddressType.Airport;
    }
    const presumedType = getPresumedAddressType(args.address);
    if ((0, value_checkers_1.isNotUndefinedOrNull)(presumedType)) {
        return presumedType;
    }
    // this is the last resort, if we don't have address with specification and no flight number
    // but the origin location is marked as airport we assume the address is an airport
    if (args.originIsAirport) {
        return legacy_enums_1.LocationAddressType.Airport;
    }
    return undefined;
}
function mergePickupAddressAndSpecification(pickupAddress, pickupAddressSpecification) {
    if (pickupAddressSpecification) {
        const presumedPickupAddressType = getPresumedAddressType(pickupAddress);
        if (presumedPickupAddressType !== legacy_enums_1.LocationAddressType.Airport) {
            return `${pickupAddress} [${getPickupAddressTypeDescription(presumedPickupAddressType)}${pickupAddressSpecification}]`;
        }
    }
    return pickupAddress;
}
//# sourceMappingURL=address-types.js.map